module.exports = __webpack_public_path__ + "img/dw.caacffd4.png";